import React, { useEffect } from 'react'

const CaptureComponent = ({ canvas, onCapture, viewerReady }) => {
  useEffect(() => {
    if (viewerReady && onCapture && canvas) {
      const captureCanvas = () => {
        const dataURL = canvas.current.toDataURL('image/png')
        onCapture(dataURL)
      }
      requestAnimationFrame(captureCanvas)
    }
  }, [viewerReady, onCapture, canvas])

  return null
}

export default CaptureComponent
